import { api } from "../api/client";
import { useState, useEffect } from "react";
import { Modal, FormGroup } from "../components/UI";

export default function Benutzer() {
  const [users, setUsers] = useState([]);
  const [gremien, setGremien] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showGremien, setShowGremien] = useState(null);
  const [alleGremien, setAlleGremien] = useState([]);
  const [userGremien, setUserGremien] = useState([]);
  const [editUser, setEditUser] = useState(null);
  const [form, setForm] = useState({ vorname: "", nachname: "", email: "", rolle: "mitglied" });
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [tempPw, setTempPw] = useState("");

  const load = () => {
    api.getInternalUsers().then(setUsers).catch(() => {});
    api.getGremien().then(setGremien).catch(() => {});
  };

  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (editUser) {
        await api.updateInternalUser(editUser.id, form);
        setSuccess("Benutzer aktualisiert.");
      } else {
        const res = await api.createInternalUser(form);
        setTempPw(res.temp_passwort);
        setSuccess(`Benutzer angelegt. Temporäres Passwort: ${res.temp_passwort}`);
      }
      setShowForm(false); setEditUser(null);
      setForm({ vorname: "", nachname: "", email: "", rolle: "mitglied" });
      load();
    } catch { setError("Fehler beim Speichern."); }
  };

  const del = async (u) => {
    if (!window.confirm(`${u.vorname} ${u.nachname} wirklich löschen?`)) return;
    await api.deleteInternalUser(u.id);
    load();
  };

  const openEdit = (u) => {
    setEditUser(u);
    setForm({ vorname: u.vorname, nachname: u.nachname, email: u.email, rolle: u.rolle, strasse: u.strasse || '', hausnummer: u.hausnummer || '', plz: u.plz || '', ort: u.ort || '', telefon: u.telefon || '', funktion: u.funktion || '' });
    setShowForm(true);
  };

  const rolleLabel = { superadmin: "Super-Admin", admin: "Admin", mitglied: "Mitglied" };
  const rolleBadgeColor = { superadmin: "var(--danger)", admin: "var(--warn)", mitglied: "var(--info)" };

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="breadcrumb">Verwaltung</div>
          <h1 className="page-title">Benutzer</h1>
        </div>
        <button className="btn btn-primary" onClick={() => { setEditUser(null); setForm({ vorname: "", nachname: "", email: "", rolle: "mitglied" }); setShowForm(true); }}>
          + Benutzer anlegen
        </button>
      </div>

      {success && <div className="alert alert-success" style={{ marginBottom: 16 }}>{success}</div>}
      {error && <div className="alert alert-error" style={{ marginBottom: 16 }}>{error}</div>}

      <div className="card">
        <table className="table">
          <thead>
            <tr><th>Name</th><th>E-Mail</th><th>Rolle</th><th>Status</th><th></th></tr>
          </thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id}>
                <td><strong>{u.nachname}, {u.vorname}</strong></td>
                <td style={{ fontFamily: "var(--mono)", fontSize: 12 }}>{u.email}</td>
                <td>
                  <span style={{ fontSize: 11, fontWeight: 600, color: rolleBadgeColor[u.rolle], border: `1px solid ${rolleBadgeColor[u.rolle]}`, padding: "2px 8px", borderRadius: 99 }}>
                    {rolleLabel[u.rolle]}
                  </span>
                </td>
                <td>
                  {u.aktiv
                    ? <span style={{ color: "#2e7d32", fontSize: 12 }}>✓ Aktiv</span>
                    : <span style={{ color: "#999", fontSize: 12 }}>✕ Gesperrt</span>}
                  {u.muss_passwort_aendern && <span style={{ fontSize: 11, color: "#e65100", marginLeft: 8 }}>⚠ PW ändern</span>}
                </td>
                <td>
                  <div style={{ display: "flex", gap: 4 }}>
                    <button className="btn btn-ghost btn-sm btn-icon" title="Bearbeiten" aria-label="Bearbeiten" onClick={() => openEdit(u)}>✎</button>
                    <button className="btn btn-ghost btn-sm btn-icon" title="Löschen" aria-label="Löschen" onClick={() => del(u)}>🗑</button>
                    <button className="btn btn-ghost btn-sm btn-icon" title="Gremien zuweisen" onClick={async () => {
                      const [g, ug] = await Promise.all([api.getGremien(), api.getUserGremien(u.id)]);
                      setAlleGremien(g);
                      setUserGremien(ug.map ? ug.map(x => x.gremium_id) : []);
                      setShowGremien(u);
                    }}>👥</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>


      {showGremien && (
        <Modal title={`Gremien — ${showGremien.vorname} ${showGremien.nachname}`}
          onClose={() => setShowGremien(null)}
          footer={<button className="btn btn-secondary" onClick={() => setShowGremien(null)}>Schließen</button>}>
          <div style={{ fontSize: 13, color: "#666", marginBottom: 12 }}>Gremien auswählen:</div>
          {alleGremien.map(g => (
            <div key={g.id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 0", borderBottom: "1px solid #f0f0f0" }}>
              <input type="checkbox" id={`g_${g.id}`}
                checked={userGremien.includes(g.id)}
                onChange={async (e) => {
                  if (e.target.checked) {
                    await api.addUserGremium(showGremien.id, g.id, { rolle: "mitglied" });
                    setUserGremien(prev => [...prev, g.id]);
                  } else {
                    await api.removeUserGremium(showGremien.id, g.id);
                    setUserGremien(prev => prev.filter(x => x !== g.id));
                  }
                }} />
              <label htmlFor={`g_${g.id}`} style={{ fontSize: 13, cursor: "pointer" }}>
                {g.name} <span style={{ color: "#999" }}>({g.kuerzel})</span>
              </label>
            </div>
          ))}
        </Modal>
      )}
      {showForm && (
        <Modal title={editUser ? "Benutzer bearbeiten" : "Neuer Benutzer"} onClose={() => setShowForm(false)}
          footer={<>
            <button className="btn btn-secondary" onClick={() => setShowForm(false)}>Abbrechen</button>
            <button className="btn btn-primary" onClick={save}>Speichern</button>
          </>}>
          <div className="form-row">
            <FormGroup label="Vorname *">
              <input className="form-control" value={form.vorname} onChange={e => setForm(f => ({ ...f, vorname: e.target.value }))} />
            </FormGroup>
            <FormGroup label="Nachname *">
              <input className="form-control" value={form.nachname} onChange={e => setForm(f => ({ ...f, nachname: e.target.value }))} />
            </FormGroup>
          </div>
          <FormGroup label="E-Mail *">
            <input type="email" className="form-control" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} />
          </FormGroup>
          <FormGroup label="Funktion / Dienstgrad">
              <input className="form-control" value={form.funktion} onChange={e => setForm(f => ({ ...f, funktion: e.target.value }))} placeholder="z. B. Wehrführer, Schriftführer" />
            </FormGroup>
            <FormGroup label="Telefon">
              <input className="form-control" value={form.telefon} onChange={e => setForm(f => ({ ...f, telefon: e.target.value }))} placeholder="z. B. 0123 456789" />
            </FormGroup>
            <div className="form-row">
              <FormGroup label="Straße">
                <input className="form-control" value={form.strasse} onChange={e => setForm(f => ({ ...f, strasse: e.target.value }))} />
              </FormGroup>
              <FormGroup label="Nr.">
                <input className="form-control" value={form.hausnummer} onChange={e => setForm(f => ({ ...f, hausnummer: e.target.value }))} style={{ maxWidth: 80 }} />
              </FormGroup>
            </div>
            <div className="form-row">
              <FormGroup label="PLZ">
                <input className="form-control" value={form.plz} onChange={e => setForm(f => ({ ...f, plz: e.target.value }))} style={{ maxWidth: 100 }} />
              </FormGroup>
              <FormGroup label="Ort">
                <input className="form-control" value={form.ort} onChange={e => setForm(f => ({ ...f, ort: e.target.value }))} />
              </FormGroup>
            </div>
            <FormGroup label="Rolle">
            <select className="form-control" value={form.rolle} onChange={e => setForm(f => ({ ...f, rolle: e.target.value }))}>
              <option value="mitglied">Mitglied</option>
              <option value="admin">Admin</option>
              <option value="superadmin">Super-Admin</option>
            </select>
          </FormGroup>
          {editUser && (
            <FormGroup label="Neues Passwort (leer = unverändert)">
              <input type="password" className="form-control" value={form.neues_passwort || ""}
                onChange={e => setForm(f => ({ ...f, neues_passwort: e.target.value }))} />
            </FormGroup>
          )}
          <FormGroup label="Aktiv">
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <input type="checkbox" checked={form.aktiv !== false}
                onChange={e => setForm(f => ({ ...f, aktiv: e.target.checked }))} />
              <span style={{ fontSize: 13 }}>Benutzer kann sich anmelden</span>
            </div>
          </FormGroup>
        </Modal>
      )}
    </div>
  );
}
